export default function Base64Image({ className, src }) {
  if (src)
    return <img src={`data:image/jpeg;base64,${src.split("'")[1]}`} className={className} alt="Base64" />;
}
